//import React from "react";
import React, { Component } from "react";
import LocalizedLink from "../containers/LocalizedLink";

const MenuLink = ({ href, text }) => (
  <LocalizedLink className="menu__link" to={href}>
    <span>{text}</span>
  </LocalizedLink>
);

class Menu extends Component {
  render() {
    return (


  <div className="menu">
      <MenuLink href="/create" text={this.props.t('menu:menuCreate')} />
      <MenuLink href="/about" text={this.props.t('menu:menuAbout')} />
      <MenuLink href="/collections" text={this.props.t('menu:menuCollections')} />
      <MenuLink href="/realisations" text={this.props.t('menu:menuRealisations')} />
      <MenuLink href="/contact" text={this.props.t('menu:menuContact')} />
      <MenuLink href="/support" text={this.props.t('menu:menuSupport')} />
  </div>
);
}
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js